module.exports = __webpack_public_path__ + "static/media/purposeAlbumArt.900fe831.jpeg";